import fetchIntercept from 'fetch-intercept';

if (!localStorage.getItem('language')) {
  localStorage.setItem('language', 'pt');
}
const languages = {
  'pt': 'pt-PT',
  'en': 'en'
};

export const interceptor = () => {

  fetchIntercept.register({
    request: function (url, config) {

      const language = localStorage.getItem('language');

      if (url.includes('?')) {
        url = `${url}&language=${languages[language]}`;
      } else {
        url = `${url}?language=${languages[language]}`;
      }
      // Modify the url or config here
      return [url, config];
    },
    requestError: function (error) {
      // Called when an error occured during another 'request' interceptor call
      return Promise.reject(error);
    },
    response: function (response) {
      // Modify the reponse object
      if (response.status === 401) {
        console.log('Redirect to login');

        window.location.replace("/#/login");
      }
      return response;
    },
    responseError: function (error) {
      // Handle an fetch error
      return Promise.reject(error);
    }
  });
};



// WEBPACK FOOTER //
// ./src/services/fecth-interceptor.js